import { produce } from 'immer';
import { v4 as uuidV4 } from 'uuid';
import { toastActions } from './types.js';
export const reducer = produce((draft, action) => {
    switch (action.type) {
        case toastActions.add: {
            const { id: propId, text, autoDismiss = true, appearance = 'clear', children, progress } = action.payload;
            const id = propId ?? uuidV4();
            draft.toasts.unshift({
                text,
                autoDismiss,
                appearance,
                id,
                children,
                progress
            });
            break;
        }
        case toastActions.remove: {
            draft.toasts = draft.toasts.filter((toast) => toast.id !== action.payload);
            break;
        }
        case toastActions.clear: {
            draft.toasts = [];
            break;
        }
    }
});
//# sourceMappingURL=reducer.js.map